import { AgTechFileUploadButton, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { AgTechStandardModal } from "@agtech/web/components/Portals/Modals/AgTechModal";
import AgTechTabbedPage from "@agtech/web/components/Pages/Tabbed/AgTechTabPage";
import { AgTechImportModalResultViewProps, isItemImportValid } from "../common/AgTechImportTypes";
import { useFailedImportResultsTabs } from "../common/AgTechImportHelpers";

export type AgTechConflictingImportResultsViewProps<TImportItem, TContext> = AgTechImportModalResultViewProps<TImportItem, TContext> & {
    onImportSubmitted: (importedItems: TImportItem[]) => Promise<void>
}

const AgTechConflictingImportResultsView = <TImportItem, TContext = {}>(props: AgTechConflictingImportResultsViewProps<TImportItem, TContext>) => {
    let successfulImports = props.importResult.items.filter(isItemImportValid);

    let failedImportResultsTabs = useFailedImportResultsTabs(props);
    
    return (
        <AgTechStandardModal
            title={`${props.content.importEntitySingular} Import Results & Conflicts`}
            details='Below are the results of your import. To proceed with importing those items that do not already exist, please click the button below.'
            body={() => <AgTechTabbedPage {...failedImportResultsTabs} />}
            footer={() => (
                <div className='column-based-vertically-centered wide container'>
                    <AgTechFileUploadButton
                        text='Upload New File'
                        icon='fas fa-upload'
                        onFileUploaded={props.onImportAgain}
                        classes='py-2 px-5'
                    />
                    {successfulImports.length > 0 && (
                        <AgTechButton
                            text={`Complete ${props.content.importEntitySingular} Import`}
                            icon='fas fa-check'
                            action={async e => {
                                let wasImportConfirmed = await e.confirmations.askForConfirmation({
                                    content: {
                                        header: `Are you sure you want to import ${successfulImports.length} ${successfulImports.length > 1 ? props.content.importEntityPlural : props.content.importEntitySingular}?`,
                                    },
                                    actions: {
                                        onConfirm: async () => {
                                            await props.onImportSubmitted(successfulImports.map(e => e.importedItem));
                                            return true;
                                        }
                                    }
                                });

                                return wasImportConfirmed;
                            }}
                            classes='button-highlight py-2 px-5 ml-auto'
                            styles={{ minWidth: 200 }}
                        />    
                    )}
                </div>
            )}
        />
    )
}

export default AgTechConflictingImportResultsView;